import request from "@/utils/request";
import { addUrlPerFix } from "@/utils";

export function loginByUsername(username, password) {
  const data = {
    username,
    password
  };
  return request({
    url: "/login/login",
    method: "post",
    data
  });
}

export function logout() {
  return request({
    url: "/login/logout",
    method: "post"
  });
}

export function getUserInfo(data) {
  return request({
    url:
      addUrlPerFix(process.env.VUE_APP_BASEP_URL) + "/apis/basap/getUserInfo",
    method: "post",
    data
  });
}

export function getAuthMenu(data) {
  return request({
    url: "apis/demo/app/getAuthMenu",
    method: "post",
    data
  });
}

export function getDetail(data) {
  return request({
    url: addUrlPerFix(process.env.VUE_APP_BASEP_URL) + "/apis/basap/getDetail",
    method: "post",
    data
  });
}

export function getLogin(data) {
  return request({
    url:
      addUrlPerFix(process.env.VUE_APP_BASEP_URL) +
      "/apis/basap/visitor/getLogin",
    method: "post",
    data
  });
}
export function getAppToken(data) {
  return request({
    url: "/apis/emc/oauth2/codeRedirect",
    method: "post",
    data
  });
}

// export function getShopTypeMap (data) {
//   // TODO: 待后端接口
//   return new Promise((resolve, reject) => {
//     // 模拟网络延迟
//     setTimeout(() => {
//       const data = {
//         shopType: [
//           { code: '4', label: '平台自营店' },
//           { code: '5', label: '乡村振兴店' },
//           { code: '6', label: '二级集采店' },
//           { code: '7', label: '云租店铺' },
//           { code: '8', label: '物流店铺' },
//           { code: '9', label: '云仓店铺' },
//           { code: '10', label: '平台撮合店' },
//           { code: '11', label: '平台三方店' },
//           { code: '12', label: '平台优选店' },
//           { code: '13', label: '平台联营店' }
//         ],
//         cooperationType: [
//           { code: '0', label: '联营' },
//           { code: '3', label: '自营' },
//           { code: '4', label: '撮合' },
//           { code: '5', label: '第三方' },
//           { code: '6', label: '优选' }
//         ],
//         shopCategory: [
//           { code: '1', label: '自营' },
//           { code: '2', label: '联营' },
//           { code: '3', label: '撮合' },
//           { code: '4', label: '厂商资源' },
//           { code: '5', label: '云租店铺' },
//           { code: '6', label: '物流店铺' },
//           { code: '7', label: '云仓店铺' },
//           { code: '8', label: '第三方' },
//           { code: '9', label: '优选' }
//         ]
//       }

//       // 假设请求成功
//       resolve(data)
//     }, 500) // 模拟 500ms 的延迟
//   })
// }

export function getShopTypeMap(data = {}) {
  return request({
    url: "/apis/emc/spc/qryShopTypeDictionary",
    method: "post",
    data
  });
}
